import request from '@/utils/request'
import store from '@/store'
import axios from 'axios'


const url = store.getters.getPostUrl;
export default {
  selectPage(param){
    return request({
      url: store.getters.getPostUrl + 'mes/KPI/selectPage',
      method: 'post',
      //body
      data: param,
      //query  param
    })
  },
  selectPageDay(param){
    return request({
      url:store.getters.getPostUrl+'mes/KPI/selectPageDay',
      method:'post',
      data:param,
    })
  },
  selectExcel(param){
    return request({
      url:store.getters.getPostUrl+'mes/KPI/selectExcel',
      method:'post',
      data:param,
    })
  },
  selectDayExcel(param){
    return request({
      url:store.getters.getPostUrl+'mes/KPI/selectDayExcel',
      method:'post',
      data:param,
    })
  },
	selectDetailOperative(param){
	  return request({
	    url:store.getters.getPostUrl+'mes/KPI/selectDetailOperative',
	    method:'post',
	    data:param,
	  })
	},
	selectDetailOperativeList(param){
	  return request({
	    url:store.getters.getPostUrl+'mes/KPI/selectDetailOperativeList',
	    method:'post',
	    data:param,
	  })
	},
	selectDetailOperativeDay(param){
	  return request({
	    url:store.getters.getPostUrl+'mes/KPI/selectDetailOperativeDay',
	    method:'post',
	    data:param,
	  })
	},
	selectDetailOperativeDayList(param){
	  return request({
	    url:store.getters.getPostUrl+'mes/KPI/selectDetailOperativeDayList',
	    method:'post',
	    data:param,
	  })
	}
  // update(param){
  //   return request({
  //     url:store.getters.getPostUrl + 'mes/equipmentMonitoringService/update',
  //     method:'put',
  //     data:param
  //   })
  // },
  // selectEquipmentById(param){
  //   return request({
  //     url: store.getters.getPostUrl + 'mes/equipmentMonitoringService/selectEquipmentById',
  //     method: 'post',
  //     data: param
  //   })
  // },
}



// WEBPACK FOOTER //
// ./src/assets/js/signal/kpi.js